import { compose } from 'recompose';

import { map } from 'helpers/safeRamda';
import { theme } from 'config';
import { sortMonthTransformer, Scale } from 'scenes/Report/Report.helper';

type Sales = {
  day: string;
  totalTransactionAmount: number;
};

type Transaction = {
  day: string;
  numberOfTransactions: number;
};

const legendItems = [
  {
    title: 'Number of Transactions',
    color: theme.seafoamGreen,
  },
  {
    title: 'Sales',
    color: theme.violet,
  },
];

const salesTransformer = map(
  ({ day, totalTransactionAmount }: Sales): Scale => ({
    x: day,
    y: totalTransactionAmount,
  }),
) as Function;

const transactionTransformer = map(
  ({ day, numberOfTransactions }: Transaction): Scale => ({
    x: day,
    y: numberOfTransactions,
  }),
) as Function;

const salesTransformers = compose(
  salesTransformer,
  sortMonthTransformer('day'),
) as any;

const transactionTransformers = compose(
  transactionTransformer,
  sortMonthTransformer('day'),
) as any;

const getStartDate = (data: Scale[]): string => data[0].x.toString();
const getEndDate = (data: Scale[]): string =>
  data[data.length - 1].x.toString();

export {
  salesTransformers,
  transactionTransformers,
  legendItems,
  getStartDate,
  getEndDate,
};
